import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class UtilsService {
  constructor() {}

  capitalizeFirstLetter(str: string): string {
    if (!str) {
      return str;
    }
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  trimEndChar(inputString: string, charToTrim: string): string {
    if (inputString.endsWith(charToTrim)) {
      return inputString.slice(0, -charToTrim.length);
    }
    return inputString;
  }

  sortArrayByDate<T>(
    items: T[],
    dateKey: keyof T,
    sortOrder: "asc" | "desc" = "desc",
  ): T[] {
    const direction = sortOrder === "asc" ? 1 : -1;
    return [...items].sort((a, b) => {
      const dateA = this.getTimestampFromValue(a[dateKey]);
      const dateB = this.getTimestampFromValue(b[dateKey]);
      return (dateA - dateB) * direction;
    });
  }

  sortArrayByNumber<T>(
    items: T[],
    numberKey: keyof T,
    sortOrder: "asc" | "desc" = "desc",
  ): T[] {
    const direction = sortOrder === "asc" ? 1 : -1;
    return [...items].sort((a, b) => {
      const numberA = this.getNumberFromValue(a[numberKey]);
      const numberB = this.getNumberFromValue(b[numberKey]);
      return (numberA - numberB) * direction;
    });
  }

  private getTimestampFromValue(value: unknown): number {
    if (!value) {
      return 0;
    }

    if (value instanceof Date) {
      return value.getTime();
    }

    const parsedTime = new Date(String(value)).getTime();
    return Number.isNaN(parsedTime) ? 0 : parsedTime;
  }

  private getNumberFromValue(value: unknown): number {
    if (value === null || value === undefined || value === "") {
      return 0;
    }

    const parsedNumber = Number(value);
    return Number.isNaN(parsedNumber) ? 0 : parsedNumber;
  }
}
